// extracted by mini-css-extract-plugin
export default {"wrapper":"EditClientGeneralForm_wrapper__0Rn+y","submitWrapper":"EditClientGeneralForm_submitWrapper__XbSrZ"};